import { render, staticRenderFns } from "./HtDemension.vue?vue&type=template&id=2993c59c&scoped=true&"
import script from "./HtDemension.vue?vue&type=script&lang=js&"
export * from "./HtDemension.vue?vue&type=script&lang=js&"
import style0 from "./HtDemension.vue?vue&type=style&index=0&id=2993c59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993c59c",
  null
  
)

export default component.exports